module.exports = __webpack_public_path__ + "static/media/SEO.ff91e8f2.svg";